import request from '@/libs/request'

// 分类列表
export function categoryList (data) {
  return request({
    url: `goodsCate/info`,
    method: 'get',
    params: data
  })
}

// 删除分类
export function delCate (id) {
  return request({
    url: `goodsCate/info/${id}`,
    method: 'delete'
  })
}

// 添加分类
export function addCate (data) {
  return request({
    url: `goodsCate/info`,
    method: 'post',
    data: data
  })
}

// 分类详情
export function cateInfo (id) {
  return request({
    url: `goodsCate/info/${id}`,
    method: 'get'
  })
}

export function changeUserStatusApi (id) {
  return request({
    url: `goodsCate/changeStatus/${id}`,
    method: 'post'
  })
}

// 获取所有商品分类
export function goodsCategoryAllApi () {
  return request({
    url: `goodsCate/getAllCategory`,
    method: 'get'
  })
}
